import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { url: String, pollInterval: { type: Number, default: 0 } }

  connect () {
    this.connected = true
    this.showOutCounts = true
    this.schedulePoll()
  }

  disconnect () {
    this.connected = false
    clearTimeout(this.pollTimeout)
    this.abortController?.abort()
  }

  async refresh (params = {}) {
    clearTimeout(this.pollTimeout)
    const url = new URL(this.urlValue, window.location.origin)
    Object.entries(params).forEach(([key, value]) => url.searchParams.set(key, value))
    this.urlValue = url.toString()
    this.abortController?.abort()
    const controller = this.abortController = new AbortController()
    try {
      const response = await fetch(this.urlValue, { signal: controller.signal, headers: { Accept: 'text/html' } })
      if (!response.ok) throw new Error(`Unable to refresh table (${response.status})`)
      const html = await response.text()
      if (!this.connected || controller !== this.abortController) return
      this.element.innerHTML = html
      this.toggleOutCounts(this.showOutCounts)
    } catch (error) {
      if (error.name !== 'AbortError') throw error
    } finally {
      if (controller === this.abortController) this.schedulePoll()
    }
  }

  toggleOutCounts (visible) {
    this.showOutCounts = visible
    this.element.querySelectorAll('[data-out-count]').forEach(cell => { cell.hidden = !visible })
    this.element.querySelectorAll('[data-column-group]').forEach(cell => { cell.colSpan = visible ? 2 : 1 })
  }

  schedulePoll () {
    if (!this.connected || !this.pollIntervalValue) return
    this.pollTimeout = setTimeout(() => this.refresh(), this.pollIntervalValue)
  }
}
